/**
 * Sistema de propriedades contextuais para eventos do Amplitude
 *
 * Permite que componentes definam propriedades adicionais que serão
 * automaticamente incluídas em todos os eventos do Amplitude.
 *
 * Uso:
 * ```tsx
 * useEffect(() => {
 *   setAmplitudeContextProperties({ module: "data-hub" });
 *   return () => clearAmplitudeContextProperties();
 * }, []);
 * ```
 */

export interface AmplitudeContextProperties extends Record<string, unknown> {
	module: "data-hub"; // add more modules as needed
	team: "Dados" | "A&B Casas" | "A&B Eventos"; // add more teams as needed
}

let currentContextProperties: Partial<AmplitudeContextProperties> = {};

/**
 * Define propriedades contextuais que serão adicionadas a todos os eventos
 */
export function setAmplitudeContextProperties(
	properties: AmplitudeContextProperties,
): void {
	currentContextProperties = { ...currentContextProperties, ...properties };
}

/**
 * Remove propriedades contextuais específicas
 */
export function clearAmplitudeContextProperties(keys?: string[]): void {
	if (!keys) {
		currentContextProperties = {};
		return;
	}

	keys.forEach(key => {
		delete currentContextProperties[key];
	});
}

/**
 * Obtém todas as propriedades contextuais atuais
 * Usado internamente pelo plugin do Amplitude
 */
export function getAmplitudeContextProperties(): AmplitudeContextProperties {
	return currentContextProperties as AmplitudeContextProperties;
}
